import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { APIDeleteChild, APIDisableChild, APIDownloadUserDati, APIEnableChild, APIGetTeamList, APIUpdateChild } from "../apiRoutes"
import { BehaviorSubject, ReplaySubject } from 'rxjs';


export type PayloadUpdateMinor={
  uid:string,
  profile:{
    email: string,
    firstName?: string,
    lastName?: string,
    birthMonth?: string | number,
    birthYear?: string | number,
    gender?: string,
    country?: string
  },
  preferences?:object,
  data?:{
    pending_optins?: object[],
    pending_consents?: object[],
    favouriteSoccerTeam?: string[]
  }
};

export type PayloadExport ={
  uid: string,
  childuid?: string,
  lang: string
}
@Injectable({
  providedIn: 'root'
})
export class MinorService {
  toBeDeleted = new BehaviorSubject({uid:"",deleted:false,disabled:false});
  toBeDeleted$ = this.toBeDeleted.asObservable();

  favoriteTeam = new ReplaySubject();
  favoriteTeam$ = this.favoriteTeam.asObservable();
  constructor(
    public http: HttpClient) { 

  }

  getFavoriteTeam(id:string) {
    this.http.get<any>(environment.domainBackEnd+APIGetTeamList+id.slice(2,)).subscribe((listTeams:any)=>{
      this.favoriteTeam.next({id: id, list:listTeams});
    });
  }

  enableMinor(uid:string){
    return this.http.post<any>(environment.domainBackEnd+APIEnableChild,{uid:uid});
  }

  updateMinor(minor:PayloadUpdateMinor){
    return this.http.put<any>(environment.domainBackEnd+APIUpdateChild,minor);
  }

  deleteMinor(uid:string, signatureTimestamp:string,UIDSignature:string, tutorUID:string){
    return this.http.put<any>(environment.domainBackEnd+APIDeleteChild,{uid:uid, signatureTimestamp:signatureTimestamp,UIDSignature:UIDSignature, tutorUID: tutorUID });
  }

  disableMinorPlus(uid:string){
    return this.http.put<any>(environment.domainBackEnd+APIDisableChild,{uid:uid});
  }

  exportData(params: PayloadExport){
    return this.http.post<any>(environment.domainBackEnd+APIDownloadUserDati,params, {responseType:'text' as any});
  }
}
